module.exports = __webpack_public_path__ + "img/远程会诊.a8dde115.png";